// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import GlobalStyle from './styles/global';
import theme from './styles/theme';
import Layout from './components/Layout';
import Projects from './pages/Projects';
import CaseStudyDetail from './pages/CaseStudyDetail';

// Old /projects links may carry filter query strings; keep them across the redirect.
function RedirectHomeWithSearch() {
  const { search } = useLocation();
  return <Navigate to={{ pathname: '/', search }} replace />;
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Router>
        <Routes>
          {/* Projects is the homepage */}
          <Route element={<Layout />}>
            <Route path="/" element={<Projects />} />
            <Route path="/case-study/:id" element={<CaseStudyDetail />} />
          </Route>

          {/* Redirects for old routes */}
          <Route path="/projects" element={<RedirectHomeWithSearch />} />
          <Route path="/case-studies" element={<Navigate to="/" replace />} />
          <Route path="/lab" element={<Navigate to="/" replace />} />
          <Route path="/about" element={<Navigate to="/" replace />} />
          <Route path="/contact" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
